import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

interface ArrowCalloutProps {
  open: boolean;
  content: React.ReactNode;
  children?: React.ReactElement | null;
}

const ArrowCalloutContainer = styled('div')`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const ArrowCalloutTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      borderRadius: 0, // Square corners
      maxWidth: 200,
      border: `1px solid ${theme.palette.common.black}`,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
      '&::before': {
        border: `1px solid ${theme.palette.common.black}`, // Add border to the arrow
        borderRight: 'none', // Remove the right border from the arrow
      },
    },
  }));

const ArrowCalloutContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
`;

const ArrowCallout: React.FC<ArrowCalloutProps> = ({ open, content, children }) => {
  return (
    <ArrowCalloutContainer>
      <ArrowCalloutTooltip
        open={open}
        title={
          <ArrowCalloutContent>
            {content}
          </ArrowCalloutContent>
        }
        arrow
        placement="right"
        componentsProps={{
          tooltip: {
            sx: {
              display: 'flex',
              alignItems: 'center',
            },
          },
        }}
      >
        {children ? children : <div/>}
      </ArrowCalloutTooltip>
    </ArrowCalloutContainer>
  );
};

export default ArrowCallout;